export class Pages {
    public static MyListings : number = 0;
    public static MyQuotes : number = 1;
}